import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import clsx from "clsx";
import React from "react";
import "./DropDown.style.scss";
import { P_Props } from "./DropDown.type";

const DropDownPresenter: React.FC<P_Props> = (props) => {
  const bodyClass = clsx({
    dropdown__body: true,
    active: props.isOpen,
  });

  const openAndChangeIcon = (value: any) => {
    props.onToggleDropDown();
    props.onChangeCurrentIcon(value);
  };

  return (
    <div className="dropdown">
      <div className="dropdown__header">
        <button onClick={(e) => props.onToggleDropDown()} className="dropdown__header-left">
          <span className="dropdown__header-left__label">{props.title}</span>
          {!props.isOpen && <CaretDownOutlined />}
          {props.isOpen && <CaretUpOutlined />}
        </button>

        {!props.isOpen && Boolean(props.rightSideIcons.length) && props.isShowIcon && (
          <div className="dropdown__header-right">
            {props.rightSideIcons.map((icon) => {
              const Icon = icon.label;
              const boxClass = clsx({
                "dropdown__header-right-box": true,
                active: icon.value === props.currentIcon,
              });
              return (
                <div key={icon.id} onClick={(e) => openAndChangeIcon(icon.value)} className={boxClass}>
                  <Icon size={[20, 20]} viewBox={[20, 20]} color={"#D5DCEB"} />
                </div>
              );
            })}
          </div>
        )}
      </div>
      {props.isOpen && <div className={bodyClass}>{props.render as any}</div>}
    </div>
  );
};

export default DropDownPresenter;
